module.exports = __webpack_public_path__ + "components/incentive/static/snow-history-5cce34de3c246c4d3bee566de692226a.svg";